import {
  Box,
  Button,
  CircularProgress,
  PaginationItem,
  Paper,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import styles from "../../../styles/brsr/list.module.css";
import PaginationBox from "../../../Components/Masters/Pagination";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { api, get, put } from "../../../utils/api";
// import { useBRSR } from "../../../context/BRSRContext";
import AddIcon from "@mui/icons-material/Add";
import Add from "../../../Components/Common/Add";
import {
  checkYear,
  currentYear,
  fiscalYear,
  getYearPeriods,
} from "../../../utils/generateYearRanges";
import useBRSRStore from "../../../store/BRSRstore";
import { RssFeed } from "@mui/icons-material";

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.Mui-selected": {
    backgroundColor: "green",
    color: "#fff",
    fontWeight: "bold",
  },
  "&:hover": {
    backgroundColor: "#ededed",
  },
}));

const commonCellStyle = {
  padding: "8px",
  fontFamily: "Inter",
  fontSize: "16px",
  fontWeight: "400",
  border: "1px solid #DBDBDB",
  color: "rgba(34, 34, 34, 1)",
};

const headerCellStyle = {
  ...commonCellStyle,
  fontWeight: "600",
  fontSize: "18px",
  whiteSpace: "nowrap",
  letterSpacing: "0.5px",
  color: "rgba(34, 34, 34, 1)",
};

const actionCellStyle = {
  ...commonCellStyle,
  textDecoration: "underline",
  cursor: "pointer",
};

const BrsrList = () => {
  const tableContainerRef = useRef(null);
  // const { setBrsrId } = useBRSR();
  const { setSelectedBRSR } = useBRSRStore();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentYearFilled, setCurrentYearFilled] = useState(false);

  const [activeFilter, setActiveFilter] = useState("All");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [originalData, setOriginalData] = useState([]);
  const [data, setData] = useState([]);
  const [downloadingId, setDownloadingId] = useState(null);
  const [pdfGenerate, setPdfGenerate] = useState(false);

  const fetchData = async () => {
    try {
      const response = await get(`/brsr/get/list?page=${page}&limit=10`);
      const fetchedData = response.data.data;
      setOriginalData(fetchedData);
      setData(fetchedData);
      setTotalPages(Math.ceil(fetchedData.length / 10));
      const { fiscalYearPeriod, calendarYearPeriod } = getYearPeriods();

      const isPreviousYearFilled = fetchedData?.some(
        (el) =>
          el?.year?.includes(fiscalYearPeriod) ||
          el?.year?.includes(calendarYearPeriod)
      );

      if (isPreviousYearFilled) {
        setCurrentYearFilled(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  // useEffect(() => {
  //   fetchBRSR();
  // }, [data]);

  useEffect(() => {
    const newData = originalData.filter((item) => {
      if (activeFilter === "All") return true;
      return item.status === activeFilter;
    });
    setData(newData);
  }, [activeFilter, originalData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const [isShortContent, setIsShortContent] = useState(false);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  const handleChange = async (id, status, value) => {
    localStorage.setItem("brsrReview", JSON.stringify(value));

    // setBrsrId(id);
    try {
      const res1 =
        status &&
        (await put(`brsr/updateBRSR?id=${id}`, {
          status: status,
        }));
      setSelectedBRSR(id);
      navigate(`/brsr/instructions/${id}`);
      console.log(res1, "url");
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!pdfGenerate || !downloadingId) return;

    const intervalId = setInterval(async () => {
      try {
        console.log("pdfGenerate", pdfGenerate);
        const data = await get(`/brsr/getCompletedBRSR?id=${downloadingId}`);

        if (data?.data?.statusCode === 1) {
          setPdfGenerate(false);
          if (data?.data?.data?.pdfUrl) {
            const url = data.data.data.pdfUrl;

            const res = await fetch(url);
            const blob = await res.blob();

            const blobUrl = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = "BRSR_Report.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(blobUrl);
            setDownloadingId(null);
          }
        } else {
          console.log(data?.data?.data, "1223333");
        }
      } catch (error) {
        console.log(error, "errorinterval");
      }
    }, 60000);

    // Cleanup: clear interval when pdfGenerate becomes false or component unmounts
    return () => clearInterval(intervalId);
  }, [pdfGenerate, downloadingId]);



  return (
    <>
      <p className={styles.heading}>BRSR</p>
      {/* <p className={styles.subheading}>
        To change how frequently you want to create BRSR data, navigate to the
        Settings.
      </p> */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <div className={styles.filter_buttons}>
          {["All", "Pending", "Completed", "In Progress"].map((filter) => (
            <button
              key={filter}
              variant="contained"
              className={
                activeFilter === filter
                  ? styles["active_button"]
                  : styles["inactive_button"]
              }
              onClick={() => handleFilterChange(filter)}
            >
              {filter}
            </button>
          ))}
        </div>
        <Button
          variant="contained"
          endIcon={<AddIcon />}
          // disabled={currentYearFilled}
          sx={{
            backgroundColor: "#1c486b",
            fontSize: "16px",
            textTransform: "none",
            fontFamily: "Inter",
            fontWeight: "500",
            height: "2.5rem",
            mt: "2rem",
            "&:hover": {
              backgroundColor: "#1c486b",
              opacity: 0.9,
            },
          }}
          onClick={() => setIsModalOpen(true)}
        >
          Add New
        </Button>
      </Box>

      <TableContainer
        component={Paper}
        ref={tableContainerRef}
        style={{ marginTop: "1.5rem", backgroundColor: "#FCFCFC" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {[
                "S.No",
                "Reporting Period",
                "Reporting Year",
                "Create Date",
                "Status",
                "Action",
                // "Download",
                "Preview",
              ].map((header, index) => (
                <TableCell key={index} style={headerCellStyle}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <Add
            handleClose={() => setIsModalOpen(false)}
            title=" BRSR Report"
            addData={isModalOpen}
            // id={row?._id}
            addUrl={`brsr/add`}
            updateUrl={`brsr/updateBRSR`}
            {...{
              setsnackOpen,
              fetchData,
              data,
            }}
          />
          <TableBody className={styles.table_body}>
            {data && data.length > 0 ? (
              data?.map((row, rowIndex) => (
                <TableRow key={row?._id || rowIndex}>
                  <TableCell style={commonCellStyle}>
                    {(page - 1) * 10 + rowIndex + 1}
                  </TableCell>
                  <TableCell style={commonCellStyle}>{row?.period}</TableCell>
                  <TableCell style={commonCellStyle}>{row?.year}</TableCell>
                  <TableCell style={commonCellStyle}>
                    {new Date(row?.createdAt).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </TableCell>
                  <TableCell
                    style={{
                      ...commonCellStyle,
                      color:
                        row?.status === "Pending"
                          ? "#FF4444"
                          : row?.status === "In Progress"
                          ? "#FFBB33"
                          : row?.status === "Reviewed"
                          ? "blue"
                          : "#488257",
                    }}
                  >
                    {row?.status}
                  </TableCell>
                  <TableCell style={actionCellStyle}>
                    {
                      //  checkYear(row?.year)?
                      row?.status === "Pending" ? (
                        <Typography
                          onClick={() => handleChange(row?._id, "", false)}
                        >
                          Start
                        </Typography>
                      ) : row?.status === "In Progress" ? (
                        <Typography
                          onClick={() => handleChange(row?._id, "", false)}
                        >
                          Continue
                        </Typography>
                      ) : (
                        <Box sx={{ display: "flex", gap: 1 }}>
                          {/* <Typography
                          onClick={() => {
                            localStorage.setItem(
                              "brsrReview",
                              JSON.stringify(false)
                            );
                            navigate(`/brsr/preview/${row?._id}`);
                          }}
                        >
                          View /
                        </Typography> */}
                          <Typography
                            onClick={() =>
                              handleChange(row?._id, "Completed", true)
                            }
                          >
                            {" "}
                            Edit
                          </Typography>
                          {/* <Typography
                          onClick={()=>navigate(`/brsr/download/${row?._id}`)
                          }
                        >
                          {" "}
                          Download
                        </Typography> */}
                        </Box>
                      )
                      //
                    }
                  </TableCell>
                  {/* {row?.status === "Completed" ? (
                    <TableCell
                      style={{
                        ...actionCellStyle,
                        cursor:
                          downloadingId === row._id ? "not-allowed" : "pointer",
                        opacity: downloadingId === row._id ? 0.6 : 1,
                      }}
                      onClick={() =>
                        downloadingId !== row._id && handleDownload(row?._id)
                      }
                    >
                      {downloadingId === row._id ? (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <CircularProgress size={16} sx={{ mr: 1 }} />
                          Generating...
                        </Box>
                      ) : (
                        "Download"
                      )}
                    </TableCell>
                  ) : (
                    <TableCell>-</TableCell>
                  )} */}
                  {row?.status === "Completed" ? (
                    <TableCell
                      style={actionCellStyle}
                      onClick={() => {
                        localStorage.setItem("brsrReview", JSON.stringify(false));
                        navigate(`/brsr/preview-download/${row?._id}`);
                      }}
                    >
                      Preview
                    </TableCell>
                  ) : (
                    <TableCell>-</TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} style={{ textAlign: "center" }}>
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {totalPages > 1 && (
        <PaginationBox
          isShortContent={isShortContent}
          {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
        />
      )}
      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity || "info"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message || "No message provided"}
        </Alert>
      </Snackbar>
    </>
  );
};

export default BrsrList;